<script lang="ts">
  import { onMount } from "svelte";

  import { api, ApiError, type Entitlements } from "../../lib/api";

  let ent = $state<Entitlements | null>(null);
  let error = $state("");
  let loading = $state(true);

  onMount(async () => {
    try {
      ent = await api.entitlements();
    } catch (e) {
      error = e instanceof ApiError ? e.message : "Failed to load usage";
    } finally {
      loading = false;
    }
  });

  // Credits == tokens (Decision 5): used is the rolling-30d token total,
  // ceiling is the plan's monthly allowance.
  let pct = $derived(
    ent && ent.limits.ai_credits_monthly > 0
      ? Math.min(100, Math.round((ent.usage.ai_credits_used / ent.limits.ai_credits_monthly) * 100))
      : 0,
  );
</script>

<section class="max-w-3xl mx-auto px-6 py-16">
  <h1 class="text-3xl font-bold">Usage</h1>

  {#if loading}
    <p class="mt-6 text-slate-400">Loading…</p>
  {:else if error}
    <p class="mt-6 text-red-400">{error}</p>
  {:else if ent}
    <div class="mt-6 rounded-xl border border-white/10 p-6">
      <div class="flex justify-between text-sm text-slate-300">
        <span>AI credits (last 30 days)</span>
        <span>
          {ent.usage.ai_credits_used.toLocaleString()} /
          {ent.limits.ai_credits_monthly.toLocaleString()}
        </span>
      </div>
      <div class="mt-2 h-3 rounded-full bg-white/10 overflow-hidden">
        <div class="h-full bg-indigo-500" style="width: {pct}%"></div>
      </div>
      <p class="mt-3 text-xs text-slate-500">
        Credits are measured in AI tokens. Resets monthly on the {ent.plan} plan.
      </p>
    </div>
  {/if}
</section>
